import { render, staticRenderFns } from "./LineLinkLabel.vue?vue&type=template&id=1e639c24&scoped=true&lang=pug"
import script from "./LineLinkLabel.vue?vue&type=script&lang=js"
export * from "./LineLinkLabel.vue?vue&type=script&lang=js"
import style0 from "./LineLinkLabel.vue?vue&type=style&index=0&id=1e639c24&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e639c24",
  null
  
)

export default component.exports